import * as React from 'react';

export const ShoppingBagIcon: React.FunctionComponent = () => {
  return (
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <rect width="16" height="16" fill="white" fillOpacity="0.01" />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M9 3.5H7V2.5H7.207H8.793H9V3.5ZM12.875 3.5H10V2.3445C10 2.3115 9.987 2.28 9.9635 2.2565L9.2435 1.5365C9.22 1.513 9.1885 1.5 9.1555 1.5H6.8445C6.8115 1.5 6.78 1.513 6.7565 1.5365L6.0365 2.2565C6.013 2.28 6 2.3115 6 2.3445V3.5H3.125C3.056 3.5 3 3.556 3 3.625V10V13.3755C3 13.4445 3.0555 13.5 3.1245 13.5H3.8755C3.9445 13.5 4 13.4445 4 13.3755V10V4.5H12V10V12.37C12 12.442 11.942 12.5 11.87 12.5H7.875H7.5H5.4705C5.422 12.5 5.3775 12.5285 5.357 12.573L5.0115 13.323C4.9735 13.4055 5.034 13.5 5.125 13.5H7.5H7.875H12.291C12.6825 13.5 13 13.1825 13 12.791V10V3.625C13 3.556 12.944 3.5 12.875 3.5Z"
        fill="#3A3A3A"
      />
      <mask id="mask" type="alpha" maskUnits="userSpaceOnUse" x="3" y="1" width="10" height="13">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M9 3.5H7V2.5H7.207H8.793H9V3.5ZM12.875 3.5H10V2.3445C10 2.3115 9.987 2.28 9.9635 2.2565L9.2435 1.5365C9.22 1.513 9.1885 1.5 9.1555 1.5H6.8445C6.8115 1.5 6.78 1.513 6.7565 1.5365L6.0365 2.2565C6.013 2.28 6 2.3115 6 2.3445V3.5H3.125C3.056 3.5 3 3.556 3 3.625V10V13.3755C3 13.4445 3.0555 13.5 3.1245 13.5H3.8755C3.9445 13.5 4 13.4445 4 13.3755V10V4.5H12V10V12.37C12 12.442 11.942 12.5 11.87 12.5H7.875H7.5H5.4705C5.422 12.5 5.3775 12.5285 5.357 12.573L5.0115 13.323C4.9735 13.4055 5.034 13.5 5.125 13.5H7.5H7.875H12.291C12.6825 13.5 13 13.1825 13 12.791V10V3.625C13 3.556 12.944 3.5 12.875 3.5Z"
          fill="white"
        />
      </mask>
      <g mask={`url(#mask)`}>
        <rect width="16" height="16" fill="#3A3A3A" />
      </g>
    </svg>
  );
};
